const DeviceMenu = () => {
	/* Responsive Navigation */
	const hamBurger = document.querySelector(".hamburger");
	const mbnav = document.querySelector(".mbnav");
	const overlay = document.querySelector(".mbnav__backdrop");
	const menuWrap = document.querySelector(".mbnav .menu-wrap");
	const mainHeader = document.querySelector(".main-header");
	const mbnavInner = document.querySelector(".mbnav__inner");

	if (!hamBurger || !mbnav) {
		return;
	}

	/* Dynamically measure and set padding-top on .mbnav__inner */
	const updateHeaderPadding = () => {
		const navCapsule =
			document.querySelector(".header-nav-bar") ||
			document.querySelector(".main-header .bg-black") ||
			document.querySelector(".main-header");
		const innerTarget = document.querySelector(".mbnav__inner");

		if (navCapsule) {
			const rect = navCapsule.getBoundingClientRect();
			const headerBottom = Math.max(
				Math.round(rect.bottom),
				Math.round(navCapsule.offsetHeight + (navCapsule.offsetTop || 0)),
				110
			);

			document.documentElement.style.setProperty(
				"--header-height",
				`${headerBottom}px`
			);

			if (innerTarget) {
				innerTarget.style.setProperty(
					"padding-top",
					`${headerBottom}px`,
					"important"
				);
			}

			// Ensure menu-inner does not have conflicting padding-top
			const menuInners = document.querySelectorAll(".mbnav .menu-inner");
			menuInners.forEach((inner) => {
				inner.style.removeProperty("padding-top");
				inner.style.setProperty("padding-top", "0px", "important");
				inner.style.setProperty("overflow-y", "auto", "important");
				inner.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
			});
		}
	};

	window.addEventListener("resize", updateHeaderPadding);
	window.addEventListener("orientationchange", () => {
		setTimeout(updateHeaderPadding, 100);
		setTimeout(updateHeaderPadding, 300);
	});
	document.addEventListener("DOMContentLoaded", updateHeaderPadding);
	window.addEventListener("load", updateHeaderPadding);
	updateHeaderPadding();

	const menuClose = () => {
		hamBurger.classList.remove("is-clicked");
		document.body.classList.remove("scroll-fixed");
		mbnav.classList.remove("is-open");
		if (menuWrap) {
			const menuItems = menuWrap.querySelectorAll("li");
			menuItems.forEach((item) => {
				item.classList.remove("is-open");
			});
			document
				.querySelector(".mbnav__inner > .menu-wrap")
				?.style.setProperty("--leftSlide", "0");
		}
	};

	/* Mobile overlay click */
	if (overlay) {
		overlay.addEventListener("click", () => {
			menuClose();
		});
	}

	hamBurger.addEventListener("click", () => {
		updateHeaderPadding();
		if (hamBurger.classList.contains("is-clicked")) {
			menuClose();
		} else {
			hamBurger.classList.add("is-clicked");
			mbnav.classList.add("is-open");
			document.body.classList.add("scroll-fixed");
			updateHeaderPadding();
			setTimeout(updateHeaderPadding, 50);
			setTimeout(updateHeaderPadding, 200);
		}
	});

	const clickable = document
		.querySelector(".mbnav__state")
		?.getAttribute("data-clickable");

	const listItemsWithSubMenu = document.querySelectorAll(".mbnav li:has(ul)");
	listItemsWithSubMenu.forEach((item) => {
		item.classList.add("has-sub");
	});

	const subMenus = document.querySelectorAll(".mbnav li > ul");
	subMenus.forEach((subMenu) => {
		subMenu.classList.add("sub-menu");
	});

	const hasSubLinks = document.querySelectorAll(".mbnav .has-sub > a");
	hasSubLinks.forEach((link) => {
		const caret = document.createElement("em");
		caret.classList.add("mbnav__caret");
		link.after(caret);
	});

	const subMenuItems = document.querySelectorAll(
		".mbnav ul > li:has(ul.sub-menu)",
	);
	subMenuItems.forEach((item) => {
		const subMenu = item.querySelector(":scope > ul");
		const parentLink = item.querySelector(":scope > a");
		if (subMenu && parentLink) {
			const backClick = document.createElement("li");
			backClick.classList.add("back-click");
			backClick.textContent = parentLink.textContent.trim();
			subMenu.prepend(backClick);
		}
	});

	if (clickable === "true") {
		const caretElements = document.querySelectorAll(
			".mbnav .has-sub > .mbnav__caret",
		);
		caretElements.forEach((caret) => {
			caret.classList.add("mbnav__caret");
		});
	} else {
		const nonClickableLinks = document.querySelectorAll(
			".mbnav .has-sub > a",
		);
		nonClickableLinks.forEach((link) => {
			link.classList.add("mbnav__caret");
			link.setAttribute("href", "javascript:;");
		});
	}

	// === First part: wrapAll ===
	const menuInner = document.querySelector(".mbnav__inner");
	if (menuInner) {
		const children = Array.from(menuInner.children);

		const outerWrap = document.createElement("div");
		outerWrap.classList.add("menu-wrap");

		const innerWrap = document.createElement("div");
		innerWrap.classList.add("menu-inner");

		children.forEach((child) => {
			innerWrap.appendChild(child);
		});
		outerWrap.appendChild(innerWrap);
		menuInner.appendChild(outerWrap);

		const submenuElements = document.querySelectorAll(
			".mbnav__inner ul li.has-sub ul",
		);
		submenuElements.forEach((subMenu) => {
			const menuWrap = document.createElement("div");
			menuWrap.classList.add("menu-wrap");

			const innerWrap = document.createElement("div");
			innerWrap.classList.add("menu-inner");

			subMenu.parentNode.replaceChild(menuWrap, subMenu);
			innerWrap.appendChild(subMenu);
			menuWrap.appendChild(innerWrap);
		});

		updateHeaderPadding();
	}

	// Open menu on caret click
	const caretTriggers = document.querySelectorAll(
		".mbnav .has-sub > .mbnav__caret",
	);
	caretTriggers.forEach((trigger) => {
		trigger.addEventListener("click", function () {
			const element = this.parentElement;
			element.classList.add("is-open");
			document.body.classList.add("scroll-fixed");
			const menuLeftMove = document.querySelector(
				".mbnav__inner > .menu-wrap",
			);
			if (menuLeftMove) {
				const backMove =
					parseInt(
						window
							.getComputedStyle(menuLeftMove)
							.getPropertyValue("--leftSlide"),
						10,
					) || 0;
				menuLeftMove.style.setProperty(
					"--leftSlide",
					`${backMove + 100}%`,
				);
			}
		});
	});

	// Handle back click
	const backClicks = document.querySelectorAll(".mbnav__inner .back-click");
	backClicks.forEach((backClick) => {
		backClick.addEventListener("click", function () {
			const menuItem =
				this.closest("li.is-open") ||
				this.closest(".menu-item") ||
				this.closest(".has-sub");
			if (menuItem) {
				menuItem.classList.remove("is-open");
			}
			const menuLeftMove = document.querySelector(
				".mbnav__inner > .menu-wrap",
			);
			if (menuLeftMove) {
				const backMove =
					parseInt(
						window
							.getComputedStyle(menuLeftMove)
							.getPropertyValue("--leftSlide"),
						10,
					) || 0;
				menuLeftMove.style.setProperty(
					"--leftSlide",
					`${backMove - 100}%`,
				);
			}
		});
	});
};

export default DeviceMenu;
